<div>
  <ng-content select="app-accordion-item"></ng-content>
</div>
